import { BaseSchema, BlazeTableSchema } from '@blaze-shared/schema-domain';
import { Connection, UpdateWorkflowNode, Workflow } from '@blaze-shared/workflow-domain';

import {
  SchemaProvider,
  WORKFLOW_SCHEMA_KEY,
  WorkflowNodeSchemaProvider,
} from '../../registry/schema-provider.registry';

@WorkflowNodeSchemaProvider('Update')
export class UpdateNodeSchemaProvider extends SchemaProvider<UpdateWorkflowNode> {
  override getSchemas(
    workflow: Workflow,
    node: UpdateWorkflowNode,
    schemas: {
      input: Map<string | symbol, BaseSchema>;
      output: Map<string | symbol, BaseSchema>;
      allSchemas: Record<string, BaseSchema>;
      userSchema?: BlazeTableSchema | null;
      accountSchema?: BlazeTableSchema | null;
    },
    connections: Connection[],
  ): Map<string | symbol, BaseSchema> {
    const nodeSchemas = super.getSchemas(workflow, node, schemas, connections);

    if (node.datasetId) {
      nodeSchemas.set(WORKFLOW_SCHEMA_KEY, schemas.allSchemas[node.datasetId]);
    }

    return nodeSchemas;
  }
}
